import { OutcomeStatus, OverallOutcomeStatus } from '@/types/Outcome'

export const isFinalOverallOutcome = (overallOutcomeStatus?: OverallOutcomeStatus) =>
  overallOutcomeStatus !== undefined &&
  [
    OverallOutcomeStatus.accepted,
    OverallOutcomeStatus.pass,
    OverallOutcomeStatus.reOpened,
    OverallOutcomeStatus.rejected,
  ].includes(overallOutcomeStatus)

export const isFinalOutcome = (outcomeStatus?: OutcomeStatus) =>
  outcomeStatus !== undefined &&
  [
    OutcomeStatus.accepted,
    OutcomeStatus.conditionalPass,
    OutcomeStatus.conditionsMet,
    OutcomeStatus.pass,
    OutcomeStatus.rejected,
  ].includes(outcomeStatus)
